
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const fourDI: IProductData = {
  id: "hazelriggindustries-4di",
  name: "Hazelrigg Industries 4DI",
  description: "4 Channel Vacuum Tube Direct Box",
  specialOrder: true,
  images: ["/img/hazelriggindustries_4di_front.png", "/img/hazelriggindustries_4di_back.png"],
  details: [{
    label: "Description",
    markdown: `
A reimagining of the classic D.W.  
Fearn VT-1/F, the 4DI features 4 Channels of this legendary all-triode Vacuum Tube Direct Box design.  
Unlike the original VT-I/F Dual Channel design, the VDI is a 4-Channel offering housed in a convenient 2 space rackmount enclosure.  

An ideal solution for both studio and stage, the 4DI is offered as part of the Hazelrigg Industries Solutions Series and will deliver incredible results with amplified acoustic instruments, electric bass and guitar, synthesizers or more.  

The front panel conveniently features 4 locking ¼” Instrument Input sockets, locking Ground Lift switches for each channel as well as LED indicators for signal and Ground Lift.  
Moving to the rear panel, users will discover four sets of ¼” input and passthrough jacks (wired in parallel to the locking front panel connector) as well as 4 microphone level outputs available on XLR Connectors.  

Finally, the rear panel also features an IEC Mains Socket, Power Switch and 115V-220V Mains Selector.  

Sharing the same high-headroom circuit design as the venerable VT-I/F, the 4DI will provide stunningly dynamic results on electric bass and guitar, add power and girth to vintage (or modern!) synths and bring a depth and realism to piezo equipped acoustic instruments that simply must be heard.  
`
  }, {
    label: "Specifications",
    markdown: `
- Input: 200 mV nominal unbalanced
- Input Load Impedance: 1 megohm minimum
- Minimum Input Level: 5 mV nominal
- Maximum Input Level: 2.3 volts P-P for 1% THD
- Gain: -10 dB
- Frequency Response: +/- 0.2 dB 10 cps to 20 kc, -3 dB @ 0.5 cps and 95 kc
- THD + Noise: <0.3% 20 cps to 20 kc
- Intermodulation Distortion: <0.01% SMPTE
- Noise: minimum 90 dB below output (22 cps to 22 kc bandwidth)
- Output: Transformer Balanced (matches 150 ohm input)
- Output Level: -30 dBm nominal
- Maximum Output Level: -12 dBm
- Power Requirements: 120/220 VAC 50/60Hz 25W
- Dimensions: 6.25”W x 2.25”H x 9.5”D (15.9cm x 5.7cm x 24.2cm)
- Weight: 14 lbs. (6.35kg)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.hazelriggindustries.com/4di-di-box" target="_blank">https://www.hazelriggindustries.com/4di-di-box</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.RACK, HASHTAGS.TWO_U, HASHTAGS.DI],
    manufacturer: BRAND.HAZELRIGG,
  }
}